import { spotlight } from 'modules/Common/ui/CgSpotlight';
import { gapAnchor } from 'modules/Common/utils/gapAnchor';

const EXACT_WAIT_MS = 6000;
const FALLBACK_WAIT_MS = 2500;

export const recordFieldAnchor = (key) => gapAnchor('recordField', key);

export const recordModalAnchor = (kind) => gapAnchor('recordModal', kind);

export const FOLD_ADDRESS_KEYS = [
  'address.postcode',
  'address.UN_LOCODE',
  'address.latitude',
  'address.longitude',
];

export const foldNeeded = (focusFields, foldKeys = FOLD_ADDRESS_KEYS) =>
  (focusFields ?? []).some((key) => foldKeys.includes(key));

export function landOnRecordFields({
  fields,
  fallback,
  note = null,
  exactWaitMs = EXACT_WAIT_MS,
  signal = null,
}) {
  if (fields.length === 0) {
    return spotlight({ anchor: fallback, note, timeoutMs: FALLBACK_WAIT_MS, signal });
  }
  return spotlight({
    anchor: fields.map(recordFieldAnchor),
    fallback,
    fallbackNote: note,
    timeoutMs: exactWaitMs + FALLBACK_WAIT_MS,
    signal,
  });
}
